/**
 *  AenaHomeButton script file
 **/

import { mapActions, mapGetters } from 'vuex'
import { ACTIONS, GETTERS } from '@/store'
import setDeviceWidthClass from '@/mixins/setDeviceWidthClass'

export default {
  name: 'HomeButton',
  mixins: [setDeviceWidthClass],
  components: {},
  props: {},
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      building: GETTERS.GET_BUILDING,
      floor: GETTERS.GET_FLOOR,
      poi: GETTERS.GET_POI_ID
    }),
    disabled () {
      return !this.building || !this.floor
    }
  },
  methods: {
    ...mapActions([
      ACTIONS.LOAD_FLOOR,
      ACTIONS.LOAD_ROUTE,
      ACTIONS.CLEAR_ROUTE,
      ACTIONS.RESET_BBOX,
      ACTIONS.SET_HOME_POSITION
    ]),
    onReset () {
      // MUPI mode or default mode
      if (this.poi) {
        this[ACTIONS.SET_HOME_POSITION](this.poi)
      } else {
        this[ACTIONS.LOAD_FLOOR]()
        this[ACTIONS.LOAD_ROUTE]({
          reset: true,
          routeMode: false
        })
      }
      this[ACTIONS.CLEAR_ROUTE]()
      this[ACTIONS.RESET_BBOX]()
    }
  }
}
